import { render } from "./OrdersListView.vue?vue&type=template&id=857ffbc2&scoped=true"
import script from "./OrdersListView.vue?vue&type=script&lang=js"
export * from "./OrdersListView.vue?vue&type=script&lang=js"

import "./OrdersListView.vue?vue&type=style&index=0&id=857ffbc2&scoped=true&lang=css"
import "./OrdersListView.vue?vue&type=style&index=1&id=857ffbc2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-857ffbc2"]])

export default __exports__